// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__xa0bk","icon":"style_icon__QWdlJ","badge":"style_badge__n7T1t"};